"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var pageContext;
var pageContextManager = {
    getStartPageNumber: function () {
        return lodash_1.default.get(pageContext, 'startPageNum', 0);
    },
    hasExportHadContent: function () {
        return lodash_1.default.get(pageContext, 'anySectionHasContent', false);
    },
    isPageContextSet: function () {
        return !!pageContext;
    },
    setPageContext: function (value) {
        pageContext = lodash_1.default.cloneDeep(value);
    }
};
(function (module) {
    module.factory('pr.pageContextManager', function () { return pageContextManager; });
})(angular_1.module('qualtrics.pr'));
